import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=b2c995c0"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"
import style0 from "./Menu.vue?vue&type=style&index=0&id=b2c995c0&prod&lang=css"
import style1 from "./Menu.vue?vue&type=style&index=1&id=b2c995c0&prod&lang=scss"
import style2 from "./Menu.vue?vue&type=style&index=2&id=b2c995c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports